module.exports = __webpack_public_path__ + "img/ring_g_o_null_null.d995eb5f.png";